"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DOMException = require("domexception");

var idlUtils = require("../generated/utils.js");

var attributes = require("../attributes.js");

var _require = require("../helpers/namespaces"),
    HTML_NS = _require.HTML_NS;

exports.implementation = /*#__PURE__*/function () {
  function NamedNodeMapImpl(args, privateData) {
    _classCallCheck(this, NamedNodeMapImpl);

    this._element = privateData.element;
  }

  _createClass(NamedNodeMapImpl, [{
    key: "item",
    value: function item(index) {
      if (index >= this._attributeList.length) {
        return null;
      }

      return this._attributeList[index];
    }
  }, {
    key: "getNamedItem",
    value: function getNamedItem(qualifiedName) {
      return attributes.getAttributeByName(this._element, qualifiedName);
    }
  }, {
    key: "getNamedItemNS",
    value: function getNamedItemNS(namespace, localName) {
      return attributes.getAttributeByNameNS(this._element, namespace, localName);
    }
  }, {
    key: "setNamedItem",
    value: function setNamedItem(attr) {
      return attributes.setAttribute(this._element, attr);
    }
  }, {
    key: "setNamedItemNS",
    value: function setNamedItemNS(attr) {
      return attributes.setAttribute(this._element, attr);
    }
  }, {
    key: "removeNamedItem",
    value: function removeNamedItem(qualifiedName) {
      var attr = attributes.removeAttributeByName(this._element, qualifiedName);

      if (attr === null) {
        throw new DOMException("Tried to remove an attribute that was not present", "NotFoundError");
      }

      return attr;
    }
  }, {
    key: "removeNamedItemNS",
    value: function removeNamedItemNS(namespace, localName) {
      var attr = attributes.removeAttributeByNameNS(this._element, namespace, localName);

      if (attr === null) {
        throw new DOMException("Tried to remove an attribute that was not present", "NotFoundError");
      }

      return attr;
    }
  }, {
    key: "_attributeList",
    get: function get() {
      return this._element._attributeList;
    }
  }, {
    key: idlUtils.supportedPropertyIndices,
    get: function get() {
      return this._attributeList.keys();
    }
  }, {
    key: "length",
    get: function get() {
      return this._attributeList.length;
    }
  }, {
    key: idlUtils.supportedPropertyNames,
    get: function get() {
      var names = new Set(this._attributeList.map(function (a) {
        return a._qualifiedName;
      }));
      var el = this._element;

      if (el._namespaceURI === HTML_NS && el._ownerDocument._parsingMode === "html") {
        var _iterator = _createForOfIteratorHelper(names),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var name = _step.value;
            var lowercaseName = name.toLowerCase();

            if (lowercaseName !== name) {
              names.delete(name);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return names;
    }
  }]);

  return NamedNodeMapImpl;
}();